import { Component, Input } from '@angular/core';
import { TooltipPosition } from '@angular/material/tooltip';
import { SharedConfigValues, SharedConstants } from '@app/eds';

@Component({
  selector: 'app-tooltip[tootltipText]',
  templateUrl: './tooltip.component.html',
  styleUrls: ['./tooltip.component.scss']
})
export class TooltipComponent {
  //tooltipText provide the details of the input field
  @Input() tootltipText: string = SharedConstants.EMPTY_STRING;

  // tooltip delay
  @Input() tooltipDelay: string = SharedConfigValues.TOOL_TIP_DELAY;

  // tooltip position
  @Input() tooltipPosition: TooltipPosition = 'right';

  // to disable tooltip or not.
  @Input() disabled = false;

  // custom class for tooltip
  @Input() tooltipCustomClass = '';
}
